import dayjs from 'dayjs';
import { titleCase } from 'title-case';

import type { IListing } from 'src/services/api/listings/types';

export const getListingSourceLabel = (listing: IListing) => {
    return titleCase(listing.ingestion_provider.replace(/[-_]/g, ' '));
};

export const getListingDateLabel = (listing: IListing) => {
    if (!listing.created_at) {
        return '';
    }

    return dayjs(listing.created_at).format('MMM D, YYYY');
};

export const getListingSecondaryText = (listing: IListing) => {
    const parts = [
        getListingSourceLabel(listing),
        getListingDateLabel(listing),
        listing.closed_at ? 'Inactive' : 'Active',
    ].filter(Boolean);

    return parts.join(' · ');
};
